/**
 * @description 首页-服务成效统计
 * @author cjs1992
 * @date 2020-09-14 08:53:30
 */
import { request } from "@/api/axios.js";
const url = "/portal-ywtb/web/serviceStatistical/";
/**
 * @name getAvgTransactionTime
 * @description 获取平均办理时长
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-09-14 08:55:11
 */
export function getAvgTransactionTime(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getAvgTransactionTime`,
    params: data
  });
}
/**
 * @name getGuidelineTotal
 * @description 获取事项开放清单总量
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-09-14 08:56:13
 */
export function getGuidelineTotal(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getGuidelineTotal`,
    params: data
  });
}
/**
 * @name getGuidelineSceneStatistical
 * @description 获取主题分类事项数量对比
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-09-14 09:23:34
 */
export function getGuidelineSceneStatistical(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getGuidelineSceneStatistical`,
    params: data
  });
}
/**
 * @name getTransactionGuidelineToDay
 * @description 获取今日办理事项
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-09-14 09:24:22
 */
export function getTransactionGuidelineToDay(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getTransactionGuidelineToDay`,
    params: data
  });
}
/**
 * @name getEndGuidelineToDay
 * @description 获取今日办结事项
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-09-14 09:24:55
 */
export function getEndGuidelineToDay(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getEndGuidelineToDay`,
    params: data
  });
}
/**
 * @name getGuidelineStatisticalNearYear
 * @description 获取近一年办件统计
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-09-14 09:25:45
 */
export function getGuidelineStatisticalNearYear(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getGuidelineStatisticalNearYear`,
    params: data
  });
}
/**
 * @name getGuidelineSuggestionNearYear
 * @description 获取近一年好差评统计
 * @param {}
 * @return {}
 * @author cjs1992
 * @date 2020-09-14 09:26:20
 */
export function getGuidelineSuggestionNearYear(data = {}, config = {}) {
  return request({
    method: "get",
    url: `${url}getGuidelineSuggestionNearYear`,
    params: data
  });
}



// WEBPACK FOOTER //
// ./src/api/index-fwcxtj.js